<template>
  <ModalDialog :value="show" :size="size" @closed="$emit('closed')">
    <template #header>
      <div class="text-h4 text-dark-blue font-weight-bold text-uppercase p-2">
        {{ title }}
      </div>
    </template>

    <div class="p-4">{{ message }}</div>

    <template #footer>
      <div class="d-flex align-items-center justify-content-end w-100 p-4">
        <b-button
          class="font-weight-bold mr-4"
          variant="light"
          @click="$emit('closed')"
        >
          {{ cancelText }}
        </b-button>
        <b-button
          variant="warning"
          class="font-weight-bold"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </b-button>
      </div>
    </template>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/base/ModalDialog.vue';

export default {
  name: 'ConfirmationModal',
  props: {
    message: { type: String, default: '' },
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Confirm' },
    size: { type: String, default: 'lg' },
    cancelText: { type: String, default: 'Cancel' },
    confirmText: { type: String, default: 'Confirm' },
  },
  components: {
    ModalDialog,
  },
};
</script>
